export const statusLabelMap = {
  pending_approval: "Pending Approval",
  approved: "Approved",
  rejected: "Rejected"
};

export const statusPeriodMap = [
  { label: "Today", value: "today" },
  { label: "Last 7 Days", value: "past_7_days" },
  { label: "Last 30 Days", value: "past_30_days" },
  { label: "Lifetime", value: "lifetime" },
  { label: "Custom", value: "custom_range" }
];

export const SERVICE_TYPES = [
  "Influencer Marketing Agencies",
  "Photographers / Videographers",
  "Talent Management Agencies",
  "General Marketing Services",
  "Others",
  "Influencers",
  "Marketer"
];

export const REPORT_STATUS_MAP = {
  all: "All",
  pending: "Pending",
  ignored: "Ignored",
  hidden: "Hidden"
};
